<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t("Maxsulotlar") }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input type="text" class="modern-search" :placeholder="$t('Qidiruv...')" v-model="filter"
              @input="Productlist(parent)" ref="inputText1" />
          </div>

          <!-- Brand filter -->
          <v-select
            class="header-vselect"
            :options="brandList"
            v-model="brandFilter"
            :reduce="b => b.id"
            label="name"
            :placeholder="$t('Brend')"
            :clearable="true"
            @input="onBrandChange"
          >
            <template v-slot:no-options>
              <em style="opacity:.5">{{ $t("Bo'sh") }}</em>
            </template>
          </v-select>

          <!-- Model filter (brand tanlangach faollashadi) -->
          <v-select
            class="header-vselect"
            :options="modelList"
            v-model="modelFilter"
            :reduce="m => m.id"
            label="name"
            :placeholder="brandFilter ? $t('Model') : $t('Avval brend')"
            :disabled="!brandFilter"
            :clearable="true"
            @input="onModelChange"
          >
            <template v-slot:no-options>
              <em style="opacity:.5">{{ $t("Bo'sh") }}</em>
            </template>
          </v-select>

          <!-- Filter reset -->
          <button
            v-if="brandFilter || modelFilter || filter"
            class="reset-btn"
            @click="resetFilters"
            :title="$t('Filterlarni tozalash')"
          >
            <b-icon icon="x-circle"></b-icon>
          </button>

          <!-- Excel shablon yuklab olish -->
          <button type="button" class="excel-btn tpl" @click="downloadTemplate" :disabled="excelBusy"
            :title="$t('Excel shablonni yuklab olish')">
            <b-icon icon="file-earmark-arrow-down"></b-icon> {{ $t("Shablon") }}
          </button>

          <!-- Exceldan import -->
          <button type="button" class="excel-btn imp" @click="triggerImport" :disabled="excelBusy"
            :title="$t('Exceldan yuklash')">
            <b-icon :icon="excelBusy ? 'arrow-repeat' : 'upload'" :class="{ spin: excelBusy }"></b-icon>
            {{ excelBusy ? $t("Yuklanmoqda...") : $t("Exceldan yuklash") }}
          </button>
          <input ref="importFile" type="file" accept=".xlsx,.xls" style="display:none" @change="onImportFile" />

          <!-- Papka yaratish (joriy papka ichida) -->
          <button type="button" class="excel-btn fold" @click="openFolderModal">
            <b-icon icon="folder-plus"></b-icon> {{ $t("Papka") }}
          </button>

          <!-- Tanlanganlarni papkaga ko'chirish -->
          <button v-if="selectedIds.length" type="button" class="excel-btn fold" @click="openMoveModal">
            <b-icon icon="folder-symlink"></b-icon> Papkaga ({{ selectedIds.length }})
          </button>

          <!-- Narxnoma PDF (belgilangan mahsulotlar) -->
          <button v-if="selectedIds.length" type="button" class="excel-btn nxpdf" @click="nxShow = true" :disabled="nxLoading">
            <b-icon icon="file-earmark-pdf-fill"></b-icon> Narxnoma ({{ selectedIds.length }})
          </button>

          <!-- Qo'shish -->
          <router-link :to="{ name: 'Товар модал create' }">
            <button type="button" class="add-btn" v-b-modal.modal-product>
              <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}<sup>ins</sup>
            </button>
          </router-link>
        </div>
      </div>

      <!-- PAPKA YO'LI -->
      <div class="folder-crumbs" v-if="!isFlat">
        <b-icon icon="folder2-open" variant="warning"></b-icon>
        <a href="#" @click.prevent="goFolder(0)">{{ $t("Barcha mahsulotlar") }}</a>
        <template v-for="f in folderPath">
          <span :key="'s' + f.id" class="crumb-sep">›</span>
          <a :key="'f' + f.id" href="#" @click.prevent="goFolder(f.id)">{{ f.extra_name }}</a>
        </template>
        <button v-if="currentFolder > 0" type="button" class="crumb-report" @click="openFolderReport(currentFolder)">
          <b-icon icon="bar-chart-line"></b-icon> {{ $t("Papka hisoboti") }}
        </button>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px"></th>
                <th>{{ $t("Номи") }}</th>
                <th class="th-right">{{ $t("Қолдиқ") }}</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}$</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}$</th>
                <th style="width: 185px; text-align: center;">{{ $t("AMALLAR") }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- Orqaga qaytish -->
              <tr class="navigation-row" @click="Productlist(parent)">
                <td>
                  <b-icon icon="arrow-left-circle-fill" variant="secondary"></b-icon>
                </td>
                <td>
                  <button type="button" class="go-back-btn">..</button>
                </td>
                <td colspan="6"></td>
              </tr>

              <!-- Ma'lumotlar -->
              <span style="display: contents;" v-for="(item, index) in filteredRows" :key="index">
                <tr :class="{ 'folder-row': item.is_folder, 'row-selected': isSelected(item.id) }">
                  <td @click="Select(item)" style="cursor: pointer;">
                    <input
                      v-if="!item.is_folder"
                      type="checkbox"
                      class="nx-check"
                      :checked="isSelected(item.id)"
                      @click.stop="toggleSelect(item.id)"
                      title="Narxnoma uchun belgilash"
                    />
                    <span v-else>
                      <b-icon icon="folder-fill" variant="warning" font-scale="1.1"></b-icon>
                    </span>
                    <span class="id-text">{{ item.id }}</span>
                  </td>
                  <td @click="Select(item)" style="cursor: pointer;">
                    <button type="button" :class="['item-name', { 'folder-name': item.is_folder }]">
                      <span v-if="item.parent_id > 0" style="padding:0 15px;"></span>
                      {{ item.extra_name }}
                    </button>
                  </td>
                  <td class="td-right td-balance" @click="Select(item)" style="cursor: pointer;">
                    {{ item.balance | numFormat }}
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.chakana_price | numFormat }}
                    </span>
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.chakana_dollar_price | numFormat }}
                    </span>
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.optom_price | numFormat }}
                    </span>
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.optom_dollar_price | numFormat }}
                    </span>
                  </td>
                  <td>
                    <div class="actions">
                      <button v-if="!item.is_folder" type="button" class="icon-btn rev" @click="openRevision(item)" :title="$t('Reviziya')">
                        <b-icon icon="clipboard-check"></b-icon>
                      </button>
                      <button v-else type="button" class="icon-btn rev" @click="openFolderReport(item.id)" :title="$t('Papka hisoboti')">
                        <b-icon icon="bar-chart-line"></b-icon>
                      </button>
                      <router-link :to="{ name: 'Товар модал update', params: { id: item.id } }">
                        <button type="button" class="icon-btn edit" @click="$store.state.parent_id=item.parent_id">
                          <b-icon icon="pencil-square"></b-icon>
                        </button>
                      </router-link>
                      <button type="button" class="icon-btn del" @click="Producttrash(item.id)">
                        <b-icon icon="trash"></b-icon>
                      </button>
                      <router-link :to="{ name: 'Товар модал create', params: { copy: item.id } }">
                        <button type="button" class="icon-btn copy">
                          <b-icon icon="back"></b-icon>
                        </button>
                      </router-link>
                    </div>
                  </td>
                </tr>
              </span>

              <!-- Ko'proq yuklash -->
              <tr v-if="add==true">
                <td colspan="8" class="load-more-row">
                  <button class="load-more-btn" @click="Add()">{{ $t('Eshyo') }}</button>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="filteredRows.length === 0">
                <td colspan="8" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ filteredRows.length }}</b> ta mahsulot
          </div>
        </div>
      </div>
    </div>

    <!-- EXCEL IMPORT NATIJASI MODALI -->
    <div v-if="importResult" class="rev-overlay" @click.self="importResult = null">
      <div class="rev-modal">
        <div class="rev-head">
          <h3><b-icon icon="file-earmark-excel"></b-icon> {{ $t("Import natijasi") }}</h3>
          <button class="rev-close" @click="importResult = null">&times;</button>
        </div>
        <div class="rev-body">
          <div class="imp-stats">
            <div class="imp-stat ok">
              <span class="imp-num">{{ importResult.created }}</span>
              <span class="imp-lbl">{{ $t("Qo'shildi") }}</span>
            </div>
            <div class="imp-stat skip">
              <span class="imp-num">{{ importResult.skipped }}</span>
              <span class="imp-lbl">{{ $t("O'tkazib yuborildi") }}</span>
            </div>
            <div class="imp-stat total">
              <span class="imp-num">{{ importResult.total }}</span>
              <span class="imp-lbl">{{ $t("Jami") }}</span>
            </div>
          </div>
          <div v-if="importResult.errors && importResult.errors.length" class="imp-errors">
            <div class="imp-err-title">{{ $t("Qo'shilmaganlar") }}:</div>
            <div v-for="(er, i) in importResult.errors" :key="i" class="imp-err-row">
              <span class="imp-err-loc">{{ er.row ? ($t('Qator') + ' ' + er.row) : '' }}</span>
              <span class="imp-err-name">{{ er.name || '' }}</span>
              <span class="imp-err-msg">{{ er.msg }}</span>
            </div>
          </div>
        </div>
        <div class="rev-actions">
          <button class="rev-save" @click="importResult = null">{{ $t("Yopish") }}</button>
        </div>
      </div>
    </div>

    <!-- PAPKA YARATISH -->
    <div v-if="folderModal.show" class="rev-overlay" @click.self="folderModal.show = false">
      <div class="rev-modal" style="width: 400px;">
        <div class="rev-head">
          <h3><b-icon icon="folder-plus"></b-icon> {{ $t("Yangi papka") }}</h3>
          <button class="rev-close" @click="folderModal.show = false">&times;</button>
        </div>
        <div class="rev-body">
          <label class="rev-label">{{ $t("Papka nomi") }}</label>
          <input ref="folderInput" type="text" v-model="folderModal.name" class="rev-input"
            placeholder="Masalan: Xitoydan kelgan" @keyup.enter="saveFolder" />
          <label class="rev-label mt-2">{{ $t("Qaysi papka ichida") }}</label>
          <v-select :options="folderOptions" v-model="folderModal.parent_id" :reduce="f => f.id" label="label" :clearable="false" />
          <p v-if="folderModal.error" class="folder-err">{{ folderModal.error }}</p>
        </div>
        <div class="rev-actions">
          <button class="rev-cancel" @click="folderModal.show = false">{{ $t("Bekor") }}</button>
          <button class="rev-save" :disabled="folderModal.saving" @click="saveFolder">{{ $t("Saqlash") }}</button>
        </div>
      </div>
    </div>

    <!-- PAPKAGA KO'CHIRISH -->
    <div v-if="moveModal.show" class="rev-overlay" @click.self="moveModal.show = false">
      <div class="rev-modal" style="width: 400px;">
        <div class="rev-head">
          <h3><b-icon icon="folder-symlink"></b-icon> {{ $t("Papkaga ko'chirish") }}</h3>
          <button class="rev-close" @click="moveModal.show = false">&times;</button>
        </div>
        <div class="rev-body">
          <p class="text-muted" style="font-size:13px;">{{ selectedIds.length }} ta mahsulot tanlandi.</p>
          <label class="rev-label">{{ $t("Papka") }}</label>
          <v-select :options="folderOptions" v-model="moveModal.parent_id" :reduce="f => f.id" label="label" :clearable="false" />
          <p v-if="moveModal.error" class="folder-err">{{ moveModal.error }}</p>
        </div>
        <div class="rev-actions">
          <button class="rev-cancel" @click="moveModal.show = false">{{ $t("Bekor") }}</button>
          <button class="rev-save" :disabled="moveModal.saving" @click="saveMove">{{ $t("Ko'chirish") }}</button>
        </div>
      </div>
    </div>

    <!-- NARXNOMA: OPTOM/CHAKANA TANLASH -->
    <div v-if="nxShow" class="rev-overlay" @click.self="nxShow = false">
      <div class="rev-modal" style="width: 360px;">
        <div class="rev-head">
          <h3><b-icon icon="file-earmark-pdf-fill"></b-icon> Narxnoma (PDF)</h3>
          <button class="rev-close" @click="nxShow = false">&times;</button>
        </div>
        <div class="rev-body">
          <p class="text-muted" style="font-size:13px; margin-bottom:8px;">
            {{ selectedIds.length }} ta mahsulot tanlandi.
          </p>
          <div class="nx-cur-toggle">
            <button :class="['nx-cur-btn', { active: nxCurrency === 'dollar' }]" @click="nxCurrency = 'dollar'">Dollar $</button>
            <button :class="['nx-cur-btn', { active: nxCurrency === 'som' }]" @click="nxCurrency = 'som'">So'm</button>
          </div>
          <p class="text-muted" style="font-size:13px; margin:12px 0 8px;">Qaysi narx bo'yicha chiqarilsin?</p>
          <div style="display:flex; gap:10px;">
            <button class="nx-price-btn optom" :disabled="nxLoading" @click="generateNarxnoma('optom')">Optom narx</button>
            <button class="nx-price-btn chakana" :disabled="nxLoading" @click="generateNarxnoma('chakana')">Chakana narx</button>
          </div>
          <p v-if="nxLoading" class="text-center text-muted mt-2 mb-0" style="font-size:12px;">Tayyorlanmoqda...</p>
        </div>
      </div>
    </div>

    <!-- TEZ REVIZIYA MODALI -->
    <div v-if="revModal.show" class="rev-overlay" @click.self="closeRevision">
      <div class="rev-modal">
        <div class="rev-head">
          <h3><b-icon icon="clipboard-check"></b-icon> {{ $t("Reviziya") }}</h3>
          <button class="rev-close" @click="closeRevision">&times;</button>
        </div>
        <div class="rev-body">
          <div class="rev-prod">{{ revModal.name }}</div>
          <div class="rev-row">
            <span>{{ $t("Tizimdagi qoldiq") }}:</span>
            <b :class="{ 'out-stock': revModal.currentBalance <= 0 }">{{ revModal.currentBalance }}</b>
          </div>
          <label class="rev-label">{{ $t("Ombordagi haqiqiy miqdor") }}</label>
          <input ref="revInput" type="number" min="0" v-model.number="revModal.realCount"
            class="rev-input" @keyup.enter="saveRevision" />
          <p class="rev-hint">
            <b-icon icon="info-circle"></b-icon>
            {{ $t("Kiritilgandan so'ng qoldiq to'g'rilanadi va Reviziya tarixiga yoziladi") }}
          </p>
        </div>
        <div class="rev-actions">
          <button class="rev-cancel" @click="closeRevision">{{ $t("Bekor") }}</button>
          <button class="rev-save" :disabled="revModal.saving" @click="saveRevision">
            {{ revModal.saving ? $t("Saqlanmoqda...") : $t("Saqlash") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import { buildTemplateBlob, parseProductsFromFile } from "./productExcel";
  import { printNarxnoma } from "../../Xisobot/Xisobot/narxnomaPdf";
  export default {
    name: "product",
    components: { VueAutoVirtualScrollList },
    data() {
      return {
        from: null,
        parent: 0,
        scrol: 0,
        add: true,
        page: 1,
        filter: "",
        limit: 100,
        list: [],
        update_password:"",
        sett: null,
        productlist: [],
        // Filterlar
        brandList: [],
        modelList: [],
        brandFilter: null,
        modelFilter: null,
        // Excel import/shablon
        excelBusy: false,
        importResult: null,
        // Narxnoma (PDF) — tanlangan mahsulotlar
        selectedIds: [],
        nxShow: false,
        nxLoading: false,
        nxCurrency: 'dollar',
        // Papkalar
        folderList: [],
        currentFolder: 0,
        isFlat: false,
        folderModal: { show: false, name: '', parent_id: 0, saving: false, error: '' },
        moveModal: { show: false, parent_id: 0, saving: false, error: '' },
        // Tez reviziya modali
        revModal: {
          show: false, item: null, productId: null, name: '',
          currentBalance: 0, realCount: 0, saving: false,
        },
      };
    },
    computed: {
      filterlist() {
        return this.productlist.slice(0, this.limit);
      },
      filteredRows() {
        return this.productlist;
      },
      folderMap() {
        const m = {};
        this.folderList.forEach(f => { m[f.id] = f; });
        return m;
      },
      // Joriy papkagacha bo'lgan yo'l (ildizdan)
      folderPath() {
        const path = [];
        for (let id = this.currentFolder, guard = 0; id > 0 && this.folderMap[id] && guard < 50; guard++) {
          path.unshift(this.folderMap[id]);
          id = this.folderMap[id].parent_id;
        }
        return path;
      },
      // Daraxt ko'rinishidagi papkalar ro'yxati (tanlash uchun)
      folderOptions() {
        const out = [{ id: 0, label: this.$t("— Ildiz (papkasiz)") }];
        const walk = (parent, depth) => {
          if (depth > 20) return;
          this.folderList.filter(f => f.parent_id === parent)
            .sort((a, b) => String(a.extra_name).localeCompare(String(b.extra_name)))
            .forEach(f => {
              out.push({ id: f.id, label: '   '.repeat(depth) + '📁 ' + f.extra_name });
              walk(f.id, depth + 1);
            });
        };
        walk(0, 0);
        return out;
      }
    },
    methods: {
       Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
      });
    },
      Add() {
        let self = this;
        self.page += 1;
        if (localStorage.getItem("sklad_id") > 0) {
          var datetime = null;
          var keyword = "";
          if (self.filter.length > 2) {
            keyword = self.filter;
          }
          axios({
            method: "post",
            url: "api/v1/product/all-price-balance/" + self.productlist[0].parent_id,
            data: {
              sklad_id: localStorage.getItem("sklad_id"),
              datetime: datetime,
              keyword: keyword,
              brand_id: self.brandFilter || 0,
              model_id: self.modelFilter || 0,
              page: self.page,
              limit: self.limit
            }
          })
            .then(function (response) {
              var b = self.productlist.concat(response.data);
              self.productlist = b
              if (response.data.length == self.limit) {
              } else {
                self.add = false;
              }

            });
        }
      },
      List() {
        let self = this;
        axios.get("api/v1/product/extra-name").then(response => {
          self.list = response.data;
        });
      },
      Focus() {
        if (this.from.path == "/directory/product/create") {
          setTimeout(() => {
            var set = $(".item-name").not('.folder-name');
            if (set.length > 1) set[1].focus();
          }, 100);
        } else if (this.from.params.id) {
          this.$refs.inputText1.focus();
        } else {
          this.$refs.inputText1.focus();
        }
      },
      Select(item) {
        if (item.is_folder == false) {
          let val = item.id;
          this.$store.state.parent_id=item.parent_id;
          localStorage.setItem("setted_product", val);
          this.Cacheclear();
          window.close();
        } else {
          this.goFolder(item.id);
        }
      },
      Updateset(index) {
        let self = this;
        var id = self.filteredRowsRows[index].id;
        var table = $(":focus").parents("table:eq(0)");
        self.scrol = $(".table-wrapper").scrollTop();
        var focusable = table.find("tr");
        self.sett = focusable.index($(":focus").parents("tr"));
      },
      Producttrash(id) {
        let self=this;
        self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            let self = this;
            axios({
              method: "delete",
              url: "api/v1/product/id/" + id
            }).then(function (response) {
              self.Cacheclear();
              self.$store.dispatch("Productlist");
            });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
        },
          Cacheclear() {
          let self = this;
          axios({
            method: "post",
            url: "api/v1/cache-clear/all-price-balance",
            data: {
              sklad_id: localStorage.getItem("sklad_id"),
          datetime: localStorage.getItem("created_at")
        }
      }).then(function (response) {
          self.Productlist(self.parent);
        });
    },
    Productlist(parent) {
      let self = this;
      // Brand/model filter aktiv bo'lsa — papka navigatsiyasini chetlab o'tamiz,
      // global qidiruv olib boriladi (parent_id = 0)
      const useFlat = !!(self.brandFilter || self.modelFilter || (self.filter && self.filter.length > 2));
      const effectiveParent = useFlat ? 0 : parent;
      self.isFlat = useFlat;
      if (!useFlat) {
        self.currentFolder = Number(parent) || 0;
        // ".." tugmasi bo'sh papkadan ham ota papkaga qaytishi uchun
        self.parent = self.folderMap[self.currentFolder] ? self.folderMap[self.currentFolder].parent_id : 0;
      }
      self.page = 1;
      self.add = true;

      if (localStorage.getItem("sklad_id") > 0) {
        var datetime = null;
        var keyword = "";
        if (self.filter.length > 2) {
          keyword = self.filter;
        }
        if (localStorage.getItem("created_at")) {
          datetime = localStorage.getItem("created_at");
        }
        axios({
          method: "post",
          url: "api/v1/product/all-price-balance/" + effectiveParent,
          data: {
            sklad_id: localStorage.getItem("sklad_id"),
            datetime: datetime,
            keyword: keyword,
            brand_id: self.brandFilter || 0,
            model_id: self.modelFilter || 0,
            limit: self.limit,
            page: 1,
          }
        }).then(function (response) {
          self.productlist = response.data;
          if (response.data.length > 0 && response.data[0].parent_id > 0 && !useFlat) {
            axios
              .get("api/v1/product/id/" + response.data[0].parent_id)
              .then(function (response) {
                self.parent = response.data.parent_id;
              });
          }
        });
      } else {
        self.productlist = [];
      }
    },

    // ============== PAPKALAR ==============
    loadFolders() {
      return axios.get("api/v1/product/folder-list").then(res => {
        this.folderList = (res.data || []).map(f => ({ id: f.id, parent_id: f.parent_id || 0, extra_name: f.extra_name }));
      }).catch(() => { this.folderList = []; });
    },
    goFolder(id) {
      this.Productlist(id);
      setTimeout(() => { $('.item-name:eq(0)').focus() }, 100);
    },
    openFolderReport(id) {
      this.$router.push('/xisobot/partiya?folder_id=' + id);
    },
    openFolderModal() {
      this.folderModal = { show: true, name: '', parent_id: this.currentFolder || 0, saving: false, error: '' };
      this.$nextTick(() => { if (this.$refs.folderInput) this.$refs.folderInput.focus(); });
    },
    async saveFolder() {
      const name = (this.folderModal.name || '').trim();
      if (!name) { this.folderModal.error = this.$t("Papka nomini kiriting"); return; }
      this.folderModal.saving = true;
      try {
        await axios.post('api/v1/product/folder', { name, parent_id: this.folderModal.parent_id || 0 });
        this.folderModal.show = false;
        await this.loadFolders();
        this.Cacheclear();
      } catch (e) {
        this.folderModal.error = (e.response && e.response.data && (e.response.data.message || e.response.data)) || this.$t("Xatolik");
      } finally {
        this.folderModal.saving = false;
      }
    },
    openMoveModal() {
      this.moveModal = { show: true, parent_id: this.currentFolder || 0, saving: false, error: '' };
    },
    async saveMove() {
      this.moveModal.saving = true;
      try {
        await axios.post('api/v1/product/move-to-folder', {
          product_ids: this.selectedIds, parent_id: this.moveModal.parent_id || 0,
        });
        this.moveModal.show = false;
        this.selectedIds = [];
        this.Cacheclear();
      } catch (e) {
        this.moveModal.error = (e.response && e.response.data && (e.response.data.message || e.response.data)) || this.$t("Xatolik");
      } finally {
        this.moveModal.saving = false;
      }
    },

    // Brendlar ro'yxatini yuklash
    loadBrands() {
      let self = this;
      axios.get("api/v1/brand/").then(res => {
        self.brandList = res.data || [];
      }).catch(() => { self.brandList = []; });
    },

    // Brend tanlangach — shu brand uchun modellarni yuklash
    onBrandChange(brandId) {
      this.modelFilter = null;
      this.modelList = [];
      if (brandId) {
        axios.get(`api/v1/model/?brand_id=${brandId}`).then(res => {
          this.modelList = res.data || [];
        }).catch(() => { this.modelList = []; });
      }
      this.Productlist(this.parent);
    },

    onModelChange() {
      this.Productlist(this.parent);
    },

    resetFilters() {
      this.filter = "";
      this.brandFilter = null;
      this.modelFilter = null;
      this.modelList = [];
      this.Productlist(this.parent);
    },

    // ============== EXCEL: SHABLON + IMPORT ==============
    // Barcha tanlov ro'yxatlarini (brend/model/birlik/rang/davlat) yuklab olish
    async loadAllLists() {
      const get = url => axios.get(url).then(r => r.data || []).catch(() => []);
      const [brands, models, units, colours, countries] = await Promise.all([
        get("api/v1/brand/"),
        get("api/v1/model/"),
        get("api/v1/unit/"),
        get("api/v1/colour/"),
        get("api/v1/country/"),
      ]);
      return { brands, models, units, colours, countries };
    },

    // Tanlanadigan (dropdown) ustunli tayyor shablonni yuklab olish
    async downloadTemplate() {
      this.excelBusy = true;
      try {
        const lists = await this.loadAllLists();
        await buildTemplateBlob(lists);
      } catch (e) {
        this.$store.state.errors = this.$t("Shablon yaratishda xatolik");
      } finally {
        this.excelBusy = false;
      }
    },

    triggerImport() {
      if (this.$refs.importFile) {
        this.$refs.importFile.value = "";
        this.$refs.importFile.click();
      }
    },

    async onImportFile(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.excelBusy = true;
      this.importResult = null;
      try {
        const lists = await this.loadAllLists();
        const products = await parseProductsFromFile(file, lists);
        if (!products.length) {
          this.$store.state.errors = this.$t("Faylda mahsulot topilmadi");
          return;
        }
        const res = await axios.post("api/v1/product/import", { products });
        this.importResult = res.data;
        // Ro'yxat va keshni yangilaymiz
        this.Cacheclear();
      } catch (err) {
        this.$store.state.errors =
          (err.response && err.response.data && (err.response.data.message || err.response.data)) ||
          this.$t("Import xatosi");
      } finally {
        this.excelBusy = false;
      }
    },

    // ============== NARXNOMA (PDF) — tanlangan mahsulotlar ==============
    isSelected(id) {
      return this.selectedIds.indexOf(id) !== -1;
    },
    toggleSelect(id) {
      const i = this.selectedIds.indexOf(id);
      if (i === -1) this.selectedIds.push(id);
      else this.selectedIds.splice(i, 1);
    },
    async generateNarxnoma(mode) {
      if (!this.selectedIds.length) return;
      this.nxLoading = true;
      try {
        const res = await axios.post("api/v1/report/narxnoma-by-products/", {
          product_ids: this.selectedIds,
          sklad_id: Number(localStorage.getItem("sklad_id")) || 0,
        });
        const items = (res.data && res.data.items) || [];
        if (!items.length) {
          this.$store.state.errors = this.$t("Mahsulot topilmadi");
          return;
        }
        this.nxShow = false;
        printNarxnoma(items, mode, this.nxCurrency);
      } catch (err) {
        this.$store.state.errors =
          (err.response && err.response.data && (err.response.data.message || err.response.data)) ||
          this.$t("Narxnoma chiqmadi");
      } finally {
        this.nxLoading = false;
      }
    },

    // ============== TEZ REVIZIYA (qo'lda qoldiqni to'g'rilash) ==============
    openRevision(item) {
      this.revModal = {
        show: true,
        item,
        productId: item.id,
        name: item.extra_name || item.name || '',
        currentBalance: Number(item.balance || 0),
        realCount: Number(item.balance || 0),
        saving: false,
      };
      this.$nextTick(() => {
        if (this.$refs.revInput) { this.$refs.revInput.focus(); this.$refs.revInput.select(); }
      });
    },
    closeRevision() {
      this.revModal.show = false;
    },
    async saveRevision() {
      if (this.revModal.saving) return;
      const realCount = Number(this.revModal.realCount);
      if (isNaN(realCount) || realCount < 0) {
        this.$store.state.errors = this.$t("To'g'ri miqdor kiriting");
        return;
      }
      this.revModal.saving = true;
      try {
        const sklad_id = Number(localStorage.getItem("sklad_id"));
        let count = this.revModal.currentBalance;
        let body_price = 0;
        try {
          const pb = await axios.post('api/v1/product/price-balance', {
            product_id: this.revModal.productId, sklad_id,
          });
          count = Number(pb.data.balance || 0);
          body_price = Number(pb.data.delivery_price || 0);
        } catch (e) { /* mavjud qiymatlar bilan davom */ }

        await axios.post('api/v1/revision/quick', {
          product_id: this.revModal.productId,
          real_count: realCount,
          count,
          body_price,
          sklad_id,
        });

        if (this.revModal.item) this.revModal.item.balance = realCount;
        this.closeRevision();
        // Keshni tozalab, ro'yxatni yangilaymiz (qoldiq to'g'ri ko'rinsin)
        this.Cacheclear();
      } catch (e) {
        this.$store.state.errors = (e.response && e.response.data && (e.response.data.message || e.response.data))
          || this.$t("Reviziyada xatolik");
      } finally {
        this.revModal.saving = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from;
      vm.Focus();
    });
  },
  mounted: function() {
    let self = this;
    this.loadFolders().then(() => self.Productlist(self.$store.state.parent_id));
    this.Sklad();
    this.List();
    this.loadBrands();
  }
};
</script>

<style scoped>
/* PAPKALAR */
.excel-btn.fold { background: #fffbeb; color: #b45309; border-color: #fde68a; }
.excel-btn.fold:hover { background: #f59e0b; color: #fff; }
.folder-crumbs { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin: 0 0 12px; font-size: 14px; }
.folder-crumbs a { color: #2563eb; font-weight: 600; }
.crumb-sep { color: #94a3b8; }
.crumb-report { margin-left: auto; border: 1px solid #a7f3d0; background: #ecfdf5; color: #047857; border-radius: 10px; padding: 4px 12px; font-size: 13px; font-weight: 600; cursor: pointer; }
.crumb-report:hover { background: #059669; color: #fff; }
.folder-err { margin: 8px 0 0; color: #b91c1c; font-size: 13px; }

/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

@media (max-width: 1400px) {
  .header-vselect { min-width: 150px; }
}
@media (max-width: 1100px) {
  .header-vselect { min-width: 130px; }
  .modern-search { width: 180px; }
}

/* SEARCH */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* Header filter dropdownlar */
.header-vselect {
  min-width: 180px;
  font-size: 13px;
}
.header-vselect ::v-deep .vs__dropdown-toggle {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 2px 6px;
  min-height: 40px;
}
.header-vselect ::v-deep .vs__search,
.header-vselect ::v-deep .vs__search:focus {
  font-size: 13px;
  padding: 4px 6px;
  margin: 0;
}
.header-vselect ::v-deep .vs__selected {
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
}
.header-vselect ::v-deep .vs--open .vs__dropdown-toggle {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.08);
}
.header-vselect ::v-deep .vs--disabled .vs__dropdown-toggle {
  background: #f8fafc;
  opacity: 0.7;
  cursor: not-allowed;
}

/* Filter reset tugmasi */
.reset-btn {
  background: #fff1f2;
  border: 1px solid #fecdd3;
  color: #e11d48;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.reset-btn:hover {
  background: #e11d48;
  color: white;
  border-color: #e11d48;
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  transition: 0.2s;
}

.add-btn:hover {
  transform: translateY(-1px);
}

.add-btn sup {
  font-weight: 400;
  opacity: 0.7;
}

/* EXCEL TUGMALARI */
.excel-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  transition: 0.2s;
}
.excel-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.excel-btn.tpl {
  background: #ecfdf5;
  color: #059669;
  border-color: #a7f3d0;
}
.excel-btn.tpl:hover:not(:disabled) { background: #059669; color: #fff; }
.excel-btn.imp {
  background: #eff6ff;
  color: #2563eb;
  border-color: #bfdbfe;
}
.excel-btn.imp:hover:not(:disabled) { background: #2563eb; color: #fff; }
.excel-btn.nxpdf {
  background: #fef2f2;
  color: #e11d2a;
  border-color: #fecaca;
}
.excel-btn.nxpdf:hover:not(:disabled) { background: #e11d2a; color: #fff; }
.spin { animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

/* Narxnoma checkbox + tanlangan qator */
.nx-check { width: 16px; height: 16px; cursor: pointer; vertical-align: middle; accent-color: #a142f4; }
.row-selected td { background: #faf5ff !important; }

/* Narxnoma narx tanlash tugmalari */
.nx-price-btn {
  flex: 1;
  height: 46px;
  border: none;
  border-radius: 12px;
  font-weight: 800;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.nx-price-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.nx-price-btn.optom { background: #2563eb; }
.nx-price-btn.chakana { background: #16a34a; }

/* Valyuta tanlash toggle */
.nx-cur-toggle { display: flex; gap: 8px; }
.nx-cur-btn {
  flex: 1;
  height: 40px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}
.nx-cur-btn.active { background: #1e293b; color: #fff; border-color: #1e293b; }

/* IMPORT NATIJASI */
.imp-stats {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.imp-stat {
  flex: 1;
  text-align: center;
  padding: 12px 6px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.imp-stat .imp-num { font-size: 22px; font-weight: 800; line-height: 1; }
.imp-stat .imp-lbl { font-size: 11px; font-weight: 600; opacity: 0.8; }
.imp-stat.ok { background: #ecfdf5; color: #059669; }
.imp-stat.skip { background: #fff7ed; color: #ea580c; }
.imp-stat.total { background: #f1f5f9; color: #475569; }
.imp-errors {
  max-height: 240px;
  overflow-y: auto;
  border-top: 1px solid #f1f5f9;
  padding-top: 10px;
}
.imp-err-title {
  font-size: 12px;
  font-weight: 700;
  color: #e11d48;
  margin-bottom: 6px;
}
.imp-err-row {
  display: flex;
  gap: 8px;
  font-size: 12px;
  padding: 4px 0;
  border-bottom: 1px dashed #f1f5f9;
}
.imp-err-loc { color: #94a3b8; white-space: nowrap; }
.imp-err-name { font-weight: 600; color: #334155; flex: 1; word-break: break-word; }
.imp-err-msg { color: #e11d48; white-space: nowrap; }

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table thead {
  position: sticky;
  top: 0;
  z-index: 5;
}

.custom-table th {
  background: white;
  padding: 16px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f5f9;
}

.th-right {
  text-align: right;
}

.custom-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.td-balance {
  font-weight: 700;
  color: #2c3e50;
}

.custom-table tbody tr:hover:not(.navigation-row) {
  background: #faf8ff;
}

/* NAVIGATION */
.navigation-row {
  cursor: pointer;
}

.navigation-row:hover td {
  color: #a142f4;
  background: #faf8ff;
}

.go-back-btn {
  background: none;
  border: none;
  font-weight: 700;
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
}

/* FOLDER */
.folder-row {
  background-color: #fffbeb;
}

.folder-row:hover {
  background-color: #fef3c7 !important;
}

.id-text {
  float: right;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
}

.item-name {
  background: none;
  border: none;
  font-weight: 600;
  color: #334155;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  padding: 0;
}

.folder-name {
  color: #d97706;
  font-weight: 700;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.copy {
  background: #f0fdf4;
  color: #16a34a;
}

.copy:hover {
  background: #16a34a;
  color: white;
  transform: scale(1.1);
}

.rev {
  background: #eef2ff;
  color: #4f46e5;
}

.rev:hover {
  background: #4f46e5;
  color: white;
  transform: scale(1.1);
}

/* TEZ REVIZIYA MODALI */
.rev-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.rev-modal {
  background: #fff;
  width: 380px;
  max-width: 92vw;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: rev-pop 0.2s ease-out;
}
@keyframes rev-pop {
  from { transform: scale(0.94); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.rev-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #f1f5f9;
}
.rev-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.rev-close {
  border: none;
  background: #f1f5f9;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 20px;
  color: #64748b;
  cursor: pointer;
}
.rev-close:hover { background: #e2e8f0; }
.rev-body { padding: 16px 18px; }
.rev-prod {
  font-weight: 700;
  font-size: 15px;
  color: #1e293b;
  margin-bottom: 10px;
}
.rev-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 12px;
}
.rev-row b { color: #0f172a; }
.rev-row b.out-stock { color: #ef4444; }
.rev-label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 5px;
}
.rev-input {
  width: 100%;
  height: 44px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 18px;
  font-weight: 800;
  text-align: center;
  outline: none;
}
.rev-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.12);
}
.rev-hint {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 11px;
  color: #94a3b8;
  margin: 10px 0 0;
}
.rev-actions {
  display: flex;
  gap: 10px;
  padding: 0 18px 18px;
}
.rev-cancel, .rev-save {
  flex: 1;
  height: 42px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  border: none;
}
.rev-cancel { background: #f1f5f9; color: #64748b; }
.rev-cancel:hover { background: #e2e8f0; }
.rev-save { background: #10b981; color: #fff; }
.rev-save:hover:not(:disabled) { background: #059669; }
.rev-save:disabled { opacity: 0.6; cursor: not-allowed; }

/* KO'PROQ YUKLASH */
.load-more-row {
  text-align: center;
  padding: 15px !important;
}

.load-more-btn {
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 8px 30px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.load-more-btn:hover {
  background: #a142f4;
  color: white;
}

/* FOOTER */
.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px !important;
  color: #94a3b8;
  font-style: italic;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }
}
</style>
